import { Generico } from './generico';
import { Cidade } from './cidade';

export class Endereco extends Generico {
    logradouro?: string;
    numero?: string;
    bairro?: string;
    cep?: string;
    complemento?: string;
    cidade?: Cidade;
    ibgeId?: number;

    constructor(item?) {
        super(item);
        this.cidade = new Cidade();

        if(item){
            this.logradouro = item.logradouro;
            this.numero = item.numero;
            this.bairro = item.bairro;
            this.cep = item.cep;
            this.complemento = item.complemento;
            this.ibgeId = item.ibgeId;

            if(item.cidade)
                this.cidade = new Cidade(item.cidade);
        }
    }
}
